import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from "react-query"
import { APIEndpoints } from "../constants/api-endpoints"
import { HttpRequest } from "../services/_http"
import { QueryKeys } from "./_query_keys"
import { BulkCreatePayload } from "../interfaces/search-capsules"

// Get all search capsules with pagination support
export const useSearchCapsules = (filterParams?: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.SEARCH_CAPSULES, filterParams]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.SearchCapsules,
            method,
            params: filterParams
        }),
        refetchOnWindowFocus: false,
        ...options
    })
}

// Create new search capsule
export const useCreateSearchCapsule = (options?: any) => {
    const method = 'POST'
    return useMutation(async ({data}: {data: any}) => {
        const response: any = await HttpRequest({
            url: APIEndpoints.SearchCapsules,
            method,
            data
        })
        return response?.data?.results || response?.data
    }, options)
}

// Bulk create search capsules with multiple items
export const useBulkCreateSearchCapsule = (options?: any) => {
    const method = 'POST'
    return useMutation(async ({data}: {data: BulkCreatePayload}) => {
        const response: any = await HttpRequest({
            url: `${APIEndpoints.SearchCapsules}/bulk`,
            method,
            data
        })
        return response?.data?.results || response?.data
    }, options)
}

// Bulk update search capsules - updates phrase and all items
export const useBulkUpdateSearchCapsule = (options?: any) => {
    const method = 'PATCH'
    return useMutation(async ({data}: {data: { oldPhrase: string, newPhrase: string, items: any[], status?: string }}) => {
        const response: any = await HttpRequest({
            url: `${APIEndpoints.SearchCapsules}/bulk`,
            method,
            data
        })
        return response?.data?.results || response?.data
    }, options)
}

// Update search capsule
export const useUpdateSearchCapsule = (options?: any) => {
    const method = 'PATCH'
    return useMutation(async ({capsule_id, data}: {capsule_id: string, data: any}) => {
        const response: any = await HttpRequest({
            url: `${APIEndpoints.SearchCapsules}/${capsule_id}`,
            method,
            data
        })
        return response?.data?.results || response?.data
    }, options)
}

// Toggle capsule status
export const useToggleCapsuleStatus = (options?: any) => {
    const method = 'PATCH'
    return useMutation(async ({capsule_id, status}: {capsule_id: string, status: string}) => {
        const response: any = await HttpRequest({
            url: `${APIEndpoints.SearchCapsules}/${capsule_id}`,
            method,
            data: { status }
        })
        return response?.data?.results || response?.data
    }, options)
}

// Bulk delete search capsules by phrase
export const useBulkDeleteSearchCapsule = (options?: any) => {
    const method = 'DELETE'
    return useMutation(async ({phrase}: {phrase: string}) => {
        const response: any = await HttpRequest({
            url: `${APIEndpoints.SearchCapsules}/bulk`,
            method,
            data: { phrase }
        })
        return response?.data?.results || response?.data
    }, options)
}

// Delete search capsule
export const useDeleteSearchCapsule = (options?: any) => {
    const method = 'DELETE'
    return useMutation(async ({capsule_id}: {capsule_id: string}) => {
        const response: any = await HttpRequest({
            url: `${APIEndpoints.SearchCapsules}/${capsule_id}`,
            method
        })
        return response?.data?.results || response?.data
    }, options)
}
